/* App.js*/
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import InscripcionDetalle from "./pages/InscripcionDetalle";

import Home from "./pages/Home";
import Menu1 from "./pages/Menu1";
import Menu2 from "./pages/Menu2";
import Inscripcion from "./pages/Inscripcion";
import Sesion from "./pages/Sesion";
import Registro from "./pages/Registro";
import Carrito from "./pages/Carrito";
import Verificar from "./pages/Verificar";
import Navbar from "./components/Navbar";
import CookieConsent from "./components/CookieConsent";
import PoliticaCookies from "./pages/PoliticaCookies";
import MisMatriculas from "./pages/MisMatriculas";
import HistorialMatriculas from "./pages/HistorialMatriculas";
import ResetPassword from "./pages/ResetPassword";
import Contacto from "./pages/Contacto";
import RutaProtegida from "./pages/RutaProtegida";

import "./App.css";
import OAuthOk from "./pages/OAuthOk";
import PagoOk from "./pages/PagoOk";

function App() {
  return (
    <Router>
      <Navbar />

      {/* Para que el contenido no quede debajo del navbar fijo */}
      <div style={{ paddingTop: 78 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu1" element={<Menu1 />} />
          <Route path="/menu2" element={<Menu2 />} />
          <Route path="/inscripcion" element={<Inscripcion />} />
          <Route path="/inscripcion/:campusId" element={<RutaProtegida><InscripcionDetalle /></RutaProtegida>} />
          <Route path="/sesion" element={<Sesion />} />
          <Route path="/carrito" element={<RutaProtegida><Carrito /></RutaProtegida>} />
          <Route path="/politica-cookies" element={<PoliticaCookies />} />
          <Route path="/registro" element={<Registro />} />
          <Route path="/verificar" element={<Verificar />} />
          <Route path="/verificado" element={<h2>Cuenta verificada ✅, diríjase a los menús</h2>} />
          <Route path="/revisa-tu-email" element={<h2>Revisa tu email 📧 para activar cuenta, incluido Bandeja de Correo no deseado</h2>} />
          <Route path="/oauth-ok" element={<OAuthOk />} />
          <Route path="/pago-ok" element={<PagoOk />} />
          <Route path="/mis-matriculas" element={<RutaProtegida><MisMatriculas /></RutaProtegida>} />
          <Route path="/historial-matriculas" element={<RutaProtegida><HistorialMatriculas /></RutaProtegida>} />
          <Route path="/Contacto" element={<Contacto />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Routes>
      </div>

      <CookieConsent />
      <Analytics />
    </Router>
  );
}

export default App;